import React, { memo } from 'react';

import Symbol from '@/components/atomic/atoms/data-display/icons/symbol';
import IconNames from '@/components/atomic/atoms/data-display/icons/symbol/enum';
import withExposer from '@/hocs/with-exposer';
import { BasicComponentProps } from '@/typings/generic';

const IconSliceComponent: React.FC<BasicComponentProps> = ({
	$exposerSuffix,
}) => (
	<Symbol
		$exposerSuffix={$exposerSuffix}
		id={IconNames.BUILD}
		viewBox={[0, 0, 24, 24]}
		dangerouslySetInnerHTML={{
			__html: '<path d="M5.025 24A1.026 1.026 0 0 1 4 22.974V3.012C4 1.352 5.35 0 7.011 0h9.944a3.079 3.079 0 0 1 3.076 3.076v19.888a1.025 1.025 0 0 1-1.75.727l-6.294-6.258-6.235 6.264c-.196.197-.46.302-.727.302V24zm6.958-9.042c.261 0 .523.1.723.298l5.273 5.242V3.076c0-.565-.46-1.025-1.024-1.025H7.01c-.53 0-.96.431-.96.96V20.49l5.205-5.23c.2-.201.463-.302.727-.302z"></path>',
		}}
	/>
);

const IconSlice = memo(withExposer(IconSliceComponent, 'iconSlice_BUILD'));

export default IconSlice;
